import React from 'react'
import BaseHome from '../Home/BaseHome'
import { Outlet, useNavigate } from 'react-router'
import { t } from 'i18next'

const CustomerCare = () => {
  const navigate = useNavigate()
  return (
    <BaseHome title={t("crm.customer_care")} onBackClick={()=> navigate(-1)}>
        <Outlet />
    </BaseHome>
  )
}

export default CustomerCare